import styled from 'styled-components';
import { SearchInput } from 'ui-components/src/components';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const StyledSearchInput = styled(SearchInput)`
  margin: 8px;
  margin-top: 10px;
`;
